import { ChangeDetectorRef, Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppModule } from '../../app-module';
import { PromotionsByFilterDto, reimpresionAcusesService } from './reimpresionAcuses.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseReponseGeneric } from '../../commons/class/BaseReponseGeneric.interface';
import { AuthService } from '../../commons/services/auth.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogComponent } from '../../commons/components/dialog/dialog.component';
import { AcuseDTO } from '../../commons/class/Acuse.class';
import { AlertService } from '../../commons/components/alert/alert.service';
import { AlertComponent } from '../../commons/components/alert/alert.component';
import { ListaArchivosComponent } from '../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { Documents } from '../../commons/class/archivo.inteface';
import { LoaderComponent } from '../../commons/components/loader/loader.component';
import { ExportarExcel } from "../../commons/shared/Excel/exportar-excel/exportar-excel";

const ITX_Demandas_ICOIJ = 235;
const ITX_Promociones_ICOIJ = 234;


@Component({
    selector: 'oaj-reimpresion-acuses-itx',
    templateUrl: './reimpresionAcuses.component.html',
    styleUrls: ['./reimpresionAcuses.component.css'],
    imports: [AppModule, AlertComponent, ListaArchivosComponent, LoaderComponent, ExportarExcel],
    providers: [AlertService]
})
export class ReimpresionAcusesComponent implements OnInit {
    tipoAcuseSeleccionado!: number;
    isAcuseSelected = false;
    formulario!: FormGroup;
    fechaActual: Date = new Date();
    fechaAyer: Date = new Date();
    loading = false;
    acuse!: AcuseDTO;
    datos: Observable<PromotionsByFilterDto[]> = of([]);
    datosFilter: Observable<PromotionsByFilterDto[]> = of([]);
    @ViewChild('modalArchivos') modalArchivosTpl?: TemplateRef<any>;
    lstDocumentos: Documents[] = [];
    archivosModalLoading = false;
    archivosModalFailed = false;
    sMensajeLoad = "Consultando archivos...";
    archivosModalError = '';
    isLoadingClass = false;
    columnasPromociones = [
        { header: 'Órgano Jurisdiccional', key: 'organo', width: 100 },
        { header: 'Número de Expediente', key: 'numExpediente', width: 25 },
        {
            header: 'Tipo Asunto', key: 'tipoAsuntoOriginal', width: 20,
            transform: (val: string, row: any) => row.tipoAsunto
        },
        {
            header: 'Origen', key: 'origen', width: 20,
            transform: (val: string, row: any) => {
                if (row.tipoAsunto) {
                    return 'Promociones'
                }
                else {
                    return 'Demandas';
                }
            }
        },
        {
            header: 'Fecha y Hora de Recepción', key: 'fechaRecepcion', width: 25,
            transform: (val: string) => {
                if (!val) return '';
                const fecha = new Date(val);
                return fecha.toLocaleDateString('es-MX', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) + ' ' + fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
            }
        }
    ];

    columnasDemandas = [
        { header: 'OCC / Órgano Jurisdiccional', key: 'organo', width: 100 },
        {
            header: 'Origen', key: 'origen', width: 20,
            transform: (val: string, row: any) => {
                if (row.tipoAsunto) {
                    return 'Promociones'
                }
                else {
                    return 'Demandas';
                }
            }
        },
        {
            header: 'Fecha y Hora de Recepción', key: 'fechaRecepcion', width: 25,
            transform: (val: string) => {
                if (!val) return '';
                const fecha = new Date(val);
                return fecha.toLocaleDateString('es-MX', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) + ' ' + fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
            }
        }
    ];

    columnasReporte: any[] = [];
    periodoFechaInicio!: string;
    periodoFechaFin!: string;
    nombreAutoridad!: string;

    private service: reimpresionAcusesService = inject(reimpresionAcusesService);
    private authService: AuthService = inject(AuthService);
    private modalService: NgbModal = inject(NgbModal);
    private alertService: AlertService = inject(AlertService);
    private fb: FormBuilder = inject(FormBuilder);
    private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

    constructor() {

        this.fechaAyer = new Date(this.fechaAyer.setDate(new Date().getDate() - 1));
        this.formulario = this.fb.group({
            fechaInicio: this.fb.control({ value: this.toDateInputValue(this.fechaAyer), disabled: false }, []),
            fechaFin: this.fb.control({ value: this.toDateInputValue(this.fechaActual), disabled: false }, []),
            tipo: this.fb.control({ value: 1, disabled: false }, []),
            filtroGeneral: this.fb.control({ value: null, disabled: false }, []),
            folio: this.fb.control({ value: null, disabled: false }, []),
        });
    }

    ngOnInit(): void {
        this.nombreAutoridad = '(' + this.authService.getIdOrgan() + ') ' + this.authService.getNameCourt();
        this.buscar();
    }

    /**
     * Función para buscar acuses según los filtros seleccionados, se validan los campos del formulario, se formatean las fechas al formato esperado por el backend, se obtiene el tipo de acuse seleccionado y se llama al método correspondiente del servicio para obtener los acuses filtrados, si la consulta es exitosa se asignan los datos a la propiedad datos y se muestra un mensaje de éxito, si ocurre un error durante la consulta se muestra un mensaje de error
     * @returns 
     */
    buscar() {

        if (this.formulario.invalid) { return; }

        const fechaInicio: Date = new Date(this.formulario.controls['fechaInicio'].value.replace(/-/g, '/'));
        this.periodoFechaInicio = `${fechaInicio.getDate().toString().padStart(2, '0')}/${(fechaInicio.getMonth() + 1).toString().padStart(2, '0')}/${fechaInicio.getFullYear()}`;
        const fechaFin: Date = new Date(this.formulario.controls['fechaFin'].value.replace(/-/g, '/'));
        this.periodoFechaFin = `${fechaFin.getDate().toString().padStart(2, '0')}/${(fechaFin.getMonth() + 1).toString().padStart(2, '0')}/${fechaFin.getFullYear()}`;
        const folio: string = this.formulario.controls['folio'].value;
        const tipo: number = this.formulario.controls['tipo'].value;
        this.tipoAcuseSeleccionado = this.formulario.controls['tipo'].value;
        const iOij = this.authService.getIdOrgan();
        if (tipo == 1) { //promociones
            this.service.getPromotionsByFilter(this.toDateInputValue(fechaInicio),
                this.toDateInputValue(fechaFin),
                iOij.toString(),
                folio)
                .subscribe((x: BaseReponseGeneric<PromotionsByFilterDto[]>) => {
                    if (x.succcess) {
                        this.datos = of(x.data);
                        this.columnasReporte = this.columnasPromociones;
                        this.alertService.success(`Se cargaron ${x.data.length} registros`, { autoClose: true, keepAfterRouteChange: false });
                        this.applyFilters();
                        this.changeDetectorRef.detectChanges();
                    }
                    else {
                        this.alertService.error(x.message, { autoClose: true, keepAfterRouteChange: false });
                    }
                });
        }
        else { //notificaciones 
            this.service.getDemandasByFilter(this.toDateInputValue(fechaInicio),
                this.toDateInputValue(fechaFin),
                iOij.toString(),
                folio)
                .subscribe((x: BaseReponseGeneric<PromotionsByFilterDto[]>) => {
                    if (x.succcess) {
                        this.datos = of(x.data);
                        this.columnasReporte = this.columnasDemandas;
                        this.alertService.success(`Se cargaron ${x.data.length} registros`, { autoClose: true, keepAfterRouteChange: false });
                        this.applyFilters();
                        this.changeDetectorRef.detectChanges();
                    }
                    else {
                        this.alertService.error(x.message, { autoClose: true, keepAfterRouteChange: false });
                    }
                });
        }
    }
    /*
        checkAcuseSelection() {
        }
        searchByDate() {
        }
    
        searchByFolio() {
        }*/

    onFilterInputChange(): void {
        this.applyFilters();
    }

    /**
     * Función para aplicar los filtros de búsqueda, se obtiene el valor del filtro general, se normaliza el valor para hacer una búsqueda insensible a mayúsculas y espacios, y se filtran los datos utilizando el operador map para devolver solo los elementos que coincidan con el filtro general en cualquier campo del objeto
     */
    private applyFilters(): void {
        const general = this.normalizeFilterValue('filtroGeneral');

        this.datosFilter = this.datos.pipe(
            map((items) => items.filter((item) => {
                const texto = JSON.stringify(item).toLowerCase();
                const coincideGeneral = general ? texto.includes(general) : true;
                return coincideGeneral;
            }))
        );



    }

    private normalizeFilterValue(controlName: string): string {
        return (
            this.formulario.get(controlName)?.value?.toString().trim().toLowerCase() ||
            ''
        );
    }


    /**
     * Función para obtener el acuse de una demanda, se llama al método getAcusePromocion o GetAcuseDemand del servicio según el tipo de acuse seleccionado
     * @param idDemanda 
     */
    getAcuse(idDemanda: number) {
        if (this.tipoAcuseSeleccionado == 1) {
            this.service.getAcusePromocion(idDemanda).subscribe({
                next: (response: any) => {
                    this.loading = false;
                    if (response.succcess) {
                        this.acuse = new AcuseDTO;
                        this.acuse = response.data;

                        const modalRef = this.modalService.open(DialogComponent, { backdrop: 'static', backdropClass: 'customBackdrop', size: 'lg' });
                        modalRef.componentInstance.data = { id: 1, obj: this.acuse, Title: "Acuse" };
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        modalRef.componentInstance.response.subscribe((_receivedEntry: any) => {
                            //this.reloadCurrentRoute();
                        });

                    }
                    else {
                        this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
                    }
                },
                error: (error) => {
                    this.loading = false;
                    //console.log('error envio Demanda:', error.message);
                    this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                }
            });
        }
        else {
            this.service.GetAcuseDemand(idDemanda).subscribe({
                next: (response: any) => {
                    this.loading = false;
                    if (response.succcess) {
                        this.acuse = new AcuseDTO;
                        this.acuse = response.data;

                        const modalRef = this.modalService.open(DialogComponent, { backdrop: 'static', backdropClass: 'customBackdrop', size: 'lg' });
                        modalRef.componentInstance.data = { id: 1, obj: this.acuse, Title: "Acuse" };
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        modalRef.componentInstance.response.subscribe((_receivedEntry: any) => {
                            //this.reloadCurrentRoute();
                        });

                    }
                    else {
                        this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
                    }
                },
                error: (error) => {
                    this.loading = false;
                    //console.log('error envio Demanda:', error.message);
                    this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                }
            });
        }
    }

    /**
     * Función para convertir una fecha a un valor de entrada de tipo fecha (YYYY-MM-DD)
     * @param date 
     * @returns 
     */
    private toDateInputValue(date: Date): string {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    /**
     * Función para abrir el modal de documentos, se obtiene el ID del tipo de archivo según el tipo de acuse seleccionado y se llama al método getDocuments del servicio para obtener los documentos asociados a la transacción
     * @param idTransacction 
     */
    abrirModalDocumento(idTransacction: number): void {
        const idTipoArchivo: number = this.tipoAcuseSeleccionado == 1 ? ITX_Promociones_ICOIJ : ITX_Demandas_ICOIJ;
        if (this.tipoAcuseSeleccionado == 1) {
            this.sMensajeLoad = 'Consultando documentos de promoción...';
        }
        else {
            this.sMensajeLoad = 'Consultando documentos de demanda...';
        }
        this.lstDocumentos = [];
        this.isLoadingClass = true;
        this.archivosModalLoading = true;
        this.modalService.open(this.modalArchivosTpl, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });
        this.service.getDocuments(idTransacction, idTipoArchivo)
            .subscribe({
                next: (archivos) => {
                    this.lstDocumentos = archivos ?? [];
                    this.archivosModalLoading = false;
                    this.isLoadingClass = false;
                },
                error: () => {
                    this.archivosModalError = 'Ocurrio un error al cargar documentos';
                    this.archivosModalLoading = false;
                    this.archivosModalFailed = true;
                    this.isLoadingClass = false;
                },
            });
    }

}